import { CITY_FLAGS } from '../modes/match/matchConfig';
import { MatchGame } from '../modes/match/MatchGame';

export function CityFlagsRoute() {
  return <MatchGame config={CITY_FLAGS} />;
}
